import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import paymentProcessService from 'services/paymentProcessService';
const initialState = {
  loading: false,
  paymentProcesses: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchPaymentProcess = createAsyncThunk(
  'paymentProcess/fetchPaymentProcess',
  (params = {}) => {
    return paymentProcessService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  },
);

const paymentProcessSlice = createSlice({
  name: 'paymentProcess',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchPaymentProcess.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchPaymentProcess.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.paymentProcesses = payload.data;
      state.meta = {
        total: payload.pagination.total,
      };
      state.params.page = payload.pagination.current_page;
      state.params.perPage = payload.pagination.per_page;
      state.error = '';
    });
    builder.addCase(fetchPaymentProcess.rejected, (state, action) => {
      state.loading = false;
      state.paymentProcesses = [];
      state.error = action.error.message;
    });
  },
});

export default paymentProcessSlice.reducer;
